(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3382],{

/***/ 23382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero004": function() { return /* binding */ Hero004; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14258);
/* harmony import */ var components_SocialSharing_List__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21721);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87900);
/* harmony import */ var shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32667);
/* harmony import */ var _Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5489);
/* harmony import */ var _Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var Hero004 = function(param) {
    var payload = param.payload;
    var ref;
    var headline = (ref = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var buttonText = (ref2 = payload === null || payload === void 0 ? void 0 : payload.buttonText) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var buttonLink = (ref3 = payload === null || payload === void 0 ? void 0 : payload.buttonLink) !== null && ref3 !== void 0 ? ref3 : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .RenderIf */ .$b, {
                    viewMode: shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_4__/* .VIEW_MODES.DESKTOP */ .nY.DESKTOP,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Heading1 */ .nL, {
                        className: (_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headline),
                        color: "dark",
                        children: headline
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default().block),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SocialSharing_List__WEBPACK_IMPORTED_MODULE_2__/* .List */ .a, {
                            appearance: "brand",
                            className: (_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default().social),
                            buttonClassName: (_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default().button)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .RenderIf */ .$b, {
                            viewMode: shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_4__/* .VIEW_MODES.MOBILE */ .nY.MOBILE,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Heading1 */ .nL, {
                                className: (_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headline),
                                color: "dark",
                                children: headline
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__/* .RichText */ .H, {
                                    value: description,
                                    className: (_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default().description),
                                    color: "dark"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default().circle),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .PageLink */ .H_, {
                                        link: buttonLink,
                                        className: (_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default().arrow),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                                    className: (_Hero004_module_scss__WEBPACK_IMPORTED_MODULE_5___default().icon),
                                                    name: "large_arrow_right"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Paragraph */ .nv, {
                                                color: "brand",
                                                appearance: "bigger",
                                                children: buttonText
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero004);


/***/ }),

/***/ 5489:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero004_wrapper__GRFPx","headline":"Hero004_headline__rYSm_","block":"Hero004_block__B5_Lu","content":"Hero004_content__KzLTi","description":"Hero004_description__m5ARO","social":"Hero004_social__2GxKT","button":"Hero004_button__COmi8","circle":"Hero004_circle__ZZwC2","link":"Hero004_link__QkRmW","arrow":"Hero004_arrow__eJbGU","icon":"Hero004_icon__AZRFA"};

/***/ })

}]);